/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/** Campo segreto con toggle mostra/nascondi (mai autocompletato, mai loggato). */
export const SecretInput = ({ id, label, hint, value, onChange, placeholder, testId, toggleTestId, secret = true }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <Label className="mb-1 block" htmlFor={id}>{label} {hint && <span className="text-muted-foreground">{hint}</span>}</Label>
      <div className="relative">
        <Input
          id={id}
          type={secret && !show ? 'password' : 'text'}
          autoComplete="off"
          spellCheck={false}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid={testId}
          className={secret ? 'pr-10 font-mono text-xs' : 'font-mono text-xs'}
        />
        {secret && (
          <button
            type="button"
            onClick={() => setShow((v) => !v)}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            aria-label={show ? 'Nascondi' : 'Mostra'}
            data-testid={toggleTestId}
          >
            {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        )}
      </div>
    </div>
  );
};
